import PropTypes from "prop-types";
import { Link } from "react-router";

export function ConditionCardItem({
  title,
  imageUrl,
  isIcon,
  url,
  tileHeight = 212,
  backgroundColor,
}) {
  return (
    <ConditionCardWrapper url={url}>
      {isIcon ? (
        <div
          className={`flex rounded-[28px] h-[120px] w-[120px] ${
            backgroundColor ?? ""
          } md:h-[102px] md:w-[102px]  m-auto`}
        >
          <img
            src={imageUrl}
            alt={title}
            className={`h-[${tileHeight / 4}px] m-auto`}
            loading="lazy"
          />
        </div>
      ) : (
        <img
          src={imageUrl}
          alt={title}
          className="aspect-[212/220] object-cover rounded-[28px] max-h-[220px]"
          loading="lazy"
        />
      )}
      <h6 className="mt-3 text-center text-is2-gray-800 font-medium">{title}</h6>
    </ConditionCardWrapper>
  );
}

const ConditionCardWrapper = ({ children, url }) => {
  if (url) {
    return (
      <Link to={url} className={`group relative mx-auto rounded-2xl transition-all duration-300 hover:scale-105 cursor-pointer`} >
        {children}
      </Link>
    );
  }
  return  <div className={`group relative mx-auto rounded-lg duration-300 `}>{children}</div> ;
};

ConditionCardItem.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  url: PropTypes.string,
  iconImage: PropTypes.string,
  tileHeight: PropTypes.number,
};
